import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

const getSessionId = () => {
  let id = localStorage.getItem("adams_sid");
  if (!id) {
    id = (crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`);
    localStorage.setItem("adams_sid", id);
  }
  return id;
};

export default function VisitTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    api.post("/track", { path: pathname, session_id: getSessionId(), referrer: document.referrer || "" }).catch(() => {});
  }, [pathname]);
  return null;
}
